import React from "react";

const SubFooter = () => {
  return (
    <section className="py-5 bg-gradient-primary-to-secondary text-white">
      <div className="container px-5 my-5">
        <div className="text-center">
          <h5 className="display-4 fw-bolder mb-5">
            Let's Build Something Great Together
          </h5>

          <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 fs-5 mb-4">
            <a
              href="tel:+918617294506"
              className="text-white text-decoration-none"
            >
              <i className="bi bi-telephone-fill me-2"></i>
              +91 86172 94506
            </a>

            <a
              href="mailto:dibya.careers@gmail.com"
              className="text-white text-decoration-none"
            >
              <i className="bi bi-envelope-fill me-2"></i>
              dibya.careers@gmail.com
            </a>

            <a
              href="mailto:dibya@dibyamitra.me"
              className="text-white text-decoration-none"
            >
              <i className="bi bi-envelope me-2"></i>
              dibya@dibyamitra.me
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubFooter;
